import React, {useCallback, useEffect, useState} from "react";
import { InfoBanner } from "../ui/InfoBanner";
import {
    AuthTypesInfo,
    IntegrationAuthTypes,
} from "../../constants/AppConstants";
import {Box, RadioGroup} from "@mui/material";
import IntegrationAuthTypeItem from "./auth/IntegrationAuthTypeItem";
import { AppButton } from "../ui/AppButton";
import { Loader } from "../ui/Loader";
import { useIntegrationsContext } from "../../api/integrations/IntegrationsContext";
import { useHistory, useParams } from "react-router";
import { showError } from "../../utils/NotificationUtils";
import { pathParams } from "path-params";
import { Routes } from "../../constants/Routes";
import {useI18n} from "../../i18n/I18nContext";



export function IntegrationAuthWrapper() {
    const [value, setValue] = React.useState<string | null>("");
    const [submitting, setSubmitting] = useState(false);
    const [loaded, setLoaded] = useState(false);

    const params: any = useParams();
    const { IntegrationsApi } = useIntegrationsContext();
    const history = useHistory();
    const {translate} = useI18n();

    useEffect(() => {
        IntegrationsApi.getIntegrationAuth({ params: { integrationId: params.id } })
            .then((res) => {
                if (res.errors) {
                    setLoaded(true);
                } else {
                    history.push(
                        pathParams(Routes.IntegrationEditorAuthEdit, {
                            id: params.id,
                            authId: res.payload.id,
                        })
                    );
                }
            })
            .catch((err) => {
                showError(err);
            });
    }, [IntegrationsApi, history, params]);

    const createHandler = useCallback((type) => {

        setSubmitting(true);
        IntegrationsApi.createIntegrationAuth({
            data: {
                authType: type,
                integrationId: params.id,
            },
        })
            .then((res) => {
                history.push(
                    pathParams(Routes.IntegrationEditorAuthEdit, {
                        id: params.id,
                        authId: res.payload.id,
                    })
                );
            })
            .catch((err) => {
                setSubmitting(false);
                showError(err);
            });

    },[IntegrationsApi,params,history]);


    return (
        <Box sx={{px: 6, py: 6}}>
            {!loaded ? (
                <Loader size={50} />
            ) : (
                <>
                    <h2>Authentication</h2>
                    <InfoBanner
                        title="Add Authentication"
                        description="Authentication lets users prove their identity to your app and authorize Zapier to access their data, using your API authentication scheme."
                    />
                    <div>
                        <RadioGroup
                            value={value}
                            onChange={(e) => {
                                setValue((e.target as HTMLInputElement).value);
                            }}
                        >
                            {Object.keys(IntegrationAuthTypes).map((item: any, index) => {
                                return (
                                    <IntegrationAuthTypeItem
                                        key={index}
                                        title={IntegrationAuthTypes[item]}
                                        value={item as string}
                                        description={translate(AuthTypesInfo[item].description)}
                                    />
                                );
                            })}
                        </RadioGroup>
                        <AppButton
                            loading={submitting}
                            disabled={!Boolean(value?.length) || submitting}
                            onClick={()=> createHandler(value)}
                        >
                            Save
                        </AppButton>
                    </div>
                </>
            )}
        </Box>
    );
}
